exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ordersTableContainer{width:100%;height:100%;overflow:hidden}.ordersTableContainer .tableRow td{padding-left:16px}", ""]);

